import { Flex, Paragraph } from 'theme-ui';

import { Link } from '@snippets';

import { useSearch, useSearchInput } from '../../hooks';
import { themed } from './SearchPageSuggestions.theme';

export const SearchPageSuggestions = themed(({ theme }) => {
  const [{ pageSuggestions, pageResults, pageSuggested }] = useSearch();
  const [, { setRawTerm }] = useSearchInput();

  const isAutocomplete = pageSuggested?.type === 'completed';

  return pageSuggestions?.length && (!pageResults?.length || isAutocomplete) ? (
    <Flex data-comp={SearchPageSuggestions.displayName} sx={theme.wrapper}>
      <Paragraph sx={{ mr: 2 }}>Did you mean:</Paragraph>
      {pageSuggestions.map((suggestion, index, arr) => {
        const isLast = index === arr.length - 1;
        return (
          <Link
            key={suggestion}
            href="/pages/search"
            query={{}}
            sx={theme.suggestion(isLast)}
            onClick={() => setRawTerm(suggestion)}
          >
            {suggestion}
          </Link>
        );
      })}
      <Paragraph>?</Paragraph>
    </Flex>
  ) : null;
});

SearchPageSuggestions.displayName = 'SearchPageSuggestions';
